
export const getKeysFromLocalDB = (prefix, suffix) => {
    let keys = []

    let obj = window.localStorage
    Object.keys(obj).forEach((item) => {

        if (prefix !== "" && suffix !== "") {
            if (item.startsWith(prefix) && item.endsWith(suffix)) {
                keys.push(item)
            }
        } else {
            keys.push(item)
        }
    })

    return keys
}